import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface AllocateTransportRequestApiVariables {
  regionId: string
  transportRequestId: string
}

export const useAllocateTransportRequest = (
  options?: UpdateTransportRequestOnrApiMutationOptions<never, AllocateTransportRequestApiVariables>
) =>
  useUpdateTransportRequestOnrApi<never, AllocateTransportRequestApiVariables>({
    type: 'piloteAllocateTransportRequest',
    ...options,
  })
